import { frontendURL } from '../../../helper/URLHelper';
import PowerAppStandalone from './PowerAppStandalone.vue';
import PowerAppsIndex from './PowerAppsIndex.vue';

export default {
  // Rendered inside the PowerChat shell (sidebar + topbar).
  routes: [
    {
      path: frontendURL('accounts/:accountId/apps'),
      name: 'powerapps_index',
      meta: {
        permissions: ['administrator', 'agent'],
        // ACESSO-01 (L8b): abrir os apps (`powerapps#index`, `#token`).
        escopos: ['powerapps:use'],
      },
      component: PowerAppsIndex,
    },
  ],
  // Rendered outside the shell: a PowerApp owns the whole viewport, with only
  // the OS topbar (org + back to Home) above it.
  standaloneRoutes: [
    {
      path: frontendURL('accounts/:accountId/apps/:slug'),
      name: 'powerapp',
      meta: {
        permissions: ['administrator', 'agent'],
        // ACESSO-01 (L8b): abrir os apps (`powerapps#index`, `#token`).
        escopos: ['powerapps:use'],
      },
      component: PowerAppStandalone,
    },
  ],
};
